export default __webpack_public_path__ + "static/media/Reorder.af8cdd4e.svg";